import React from 'react'
import { useCart } from '../../../hooks'

export default function DeleteItem({ itemId }) {
const { deleteLineItem } = useCart()
  return (
    <button type="button" className="hds-title__small" onClick={()=>deleteLineItem(itemId)}>
      {/* <img
        src="https://csb-72hdo-startingblock.vercel.app/images/svg/cart.svg"
        alt=""
      /> */}
      ×
    </button>
  )
}
